import type { RouteRecordRaw } from "vue-router"

const rulesRoutes: RouteRecordRaw[] = [
  {
    path: "",
    name: "rulesList",
    component: () => import("@/templates/rules/RulesList.vue")
  }
]

export default rulesRoutes
